import { baseSTSummary } from '../validations/st-summary/v1';
const summaryShape = baseSTSummary.shape.summary.shape;
const impairmentSummaryShape = baseSTSummary.shape.impairmentSummary.shape;
const functionalSummaryShape = baseSTSummary.shape.functionalSummary.shape;
const outcomeMeasuresShape = baseSTSummary.shape.outcomeMeasures.shape;
export const summaryFields = [
    { key: 'disciplinesStillProvidingCare', field: summaryShape.disciplinesStillProvidingCare, variant: 'list' },
    { key: 'initialReasonHomeTherapy', field: summaryShape.initialReasonHomeTherapy },
    { key: 'reasonStillHomebound', field: summaryShape.reasonStillHomebound },
    { key: 'impairmentsStillAddressed', field: summaryShape.impairmentsStillAddressed, variant: 'list' },
];
export const impairmentSummaryFields = [
    { key: 'initial', field: impairmentSummaryShape.initial },
    { key: 'current', field: impairmentSummaryShape.current },
    { key: 'goal', field: impairmentSummaryShape.goal },
];
export const functionalSummaryFields = [
    { key: 'initial', field: functionalSummaryShape.initial },
    { key: 'current', field: functionalSummaryShape.current },
    { key: 'goal', field: functionalSummaryShape.goal },
];
export const outcomeMeasureFields = [
    { key: 'measure', field: outcomeMeasuresShape.measure, variant: 'list' },
    { key: 'initial', field: outcomeMeasuresShape.initial },
    { key: 'current', field: outcomeMeasuresShape.current },
    { key: 'goal', field: outcomeMeasuresShape.goal },
];
